var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinBenefit = function SvgCoinBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coinBenefit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BF883D",
    d: "M18.637 9a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinBenefit_svg__b)",
    d: "M18.637 9a9 9 0 0 1-8.665 8.994A9 9 0 0 1 1.307 9 9 9 0 0 1 9.972.006 9 9 0 0 1 18.637 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0D4B1",
    d: "M15.73 2.376 3.012 15.093a9 9 0 0 1-1.14-1.538l12.32-12.319a9 9 0 0 1 1.536 1.14M18.016 5.709l-11.67 11.67a9 9 0 0 1-2.279-1.31l12.64-12.64a9 9 0 0 1 1.309 2.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinBenefit_svg__c)",
    d: "M16.63 9a6.994 6.994 0 0 1-13.986.085V9a6.994 6.994 0 0 1 6.993-6.993h.086a6.97 6.97 0 0 1 4.859 2.048A6.96 6.96 0 0 1 16.63 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAB17D",
    d: "m14.582 4.054-9.89 9.89a7 7 0 0 1-1.562-2.377 7 7 0 0 1-.486-2.482V9a6.994 6.994 0 0 1 6.993-6.993h.086a6.97 6.97 0 0 1 4.859 2.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF883D",
    d: "M16.63 9a6.994 6.994 0 0 1-7.388 6.982 6.994 6.994 0 0 0 0-13.965q.195-.01.395-.011a6.994 6.994 0 0 1 6.993 6.993"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#coinBenefit_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.01 6.777h-4.85l.624 1.368h1.434v3.076h1.37V8.144h1.421zM7.68 6.777H3.763v1.368h1.888L3.764 9.853v1.367H7.68V9.854H5.791L7.68 8.145zM11.242 9.853H9.246v-.236h1.885l-.356-.77-.217-.466H9.246v-.236h1.19l-.623-1.368H7.992v4.443h3.884z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "coinBenefit_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(124.017 5.107 4.072)scale(19.0875 20.017)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "coinBenefit_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(125.013 4.42 4.618)scale(15.021 15.9638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38E37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "coinBenefit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.637 0h18v18h-18z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "coinBenefit_svg__d",
    width: 11.745,
    height: 4.943,
    x: 3.764,
    y: 6.777,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.75 0 0 0 0 0.534654 0 0 0 0 0.240625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_527_4651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_527_4651",
    result: "shape"
  })))));
};
export default SvgCoinBenefit;